import createSculptBrushStore from './createSculptBrushStore';
import { SMOOTH_BRUSH_LIMITS } from '../lib/sculpt/smoothBrushSettings';
import { DEFAULT_BRUSH_FALLOFF } from '../lib/sculpt/brushFalloff';

/**
 * The Sculpt Smooth brush's settings, as the card shows them: millimetres and
 * percentages, converted to kernel units by `toSmoothBrushSettings`.
 */
export const SCULPT_SMOOTH_BRUSH_DEFAULTS = {
  /** Brush radius in millimetres. */
  size: SMOOTH_BRUSH_LIMITS.size.default,
  /** 1..100; roughly "how many full smoothing passes per dab". */
  strength: SMOOTH_BRUSH_LIMITS.strength.default,
  /**
   * Fixed at the smooth curve — the card no longer offers a picker. The
   * other curves stay available to `getFalloffFn` for any brush that wants
   * them; on these two, sphere/sharp/linear only ever produced a harder
   * edge than socket work wants.
   */
  falloff: DEFAULT_BRUSH_FALLOFF,
  /** Leave open-boundary (trimline rim) vertices pinned. */
  pinBoundary: true,
};

/**
 * Factory for a per-step Sculpt Smooth store.
 *
 * @param {Object} options
 * @param {string} options.name - devtools store name; must be unique per instance
 * @param {Partial<typeof SCULPT_SMOOTH_BRUSH_DEFAULTS>} [options.brushDefaults]
 * @returns {import('zustand').UseBoundStore<any>}
 */
export function createSculptSmoothStore({ name, brushDefaults = {} }) {
  return createSculptBrushStore({
    name,
    appliedMeshName: 'SculptSmoothApplied',
    brushDefaults: { ...SCULPT_SMOOTH_BRUSH_DEFAULTS, ...brushDefaults },
  });
}

export default createSculptSmoothStore;
